// This file is auto-generated by @hey-api/openapi-ts

import { queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { bulkDeleteSpaceMemoryItems, createAssistant, createAssistantTemplateFromAssistant, createDataset, createMemoryFromThread, createProject, createSpace, createSpaceMemoryItem, deleteAssistant, deleteAssistantTemplate, deleteAssistantThread, deleteDataset, deleteDataSources, deleteProject, deleteSpace, deleteSpaceMemoryItem, deleteThread, generateFileUploadUrls, generateS3PresignedUrls, generateSpaceFileUploadUrls, generateThreadMemorySummary, getAssistant, getAssistantChangelog, getAssistantTemplate, getAssistantThreadById, getDatasetById, getDragDatasetById, getDragProjectById, getProjectById, getProjectChangelog, getRagSources, getReferenceData, getSpaceById, getSpaceMemory, getSpaceMemoryItem, getSpaceMemorySyncStatus, getThreadById, getThreadMemorySummary, getUserProfile, lambdaChatChatPost, listAssistants, listAssistantTemplates, listAssistantThreads, listDatasets, listDataSources, listProjects, listProjectThreads, listSpaceMemoryItems, listSpaces, type Options, processDrag, processFiles, searchUsers, syncSpaceMemory, synthesizeSpaceMemory, updateAssistant, updateAssistantTemplate, updateAssistantThread, updateDataset, updateDataSources, updateProject, updateSpace, updateSpaceMemoryItem, updateThread, updateUserProfile } from '../sdk.gen';
import type { BulkDeleteSpaceMemoryItemsData, BulkDeleteSpaceMemoryItemsError, CreateAssistantData, CreateAssistantError, CreateAssistantResponse, CreateAssistantTemplateFromAssistantData, CreateAssistantTemplateFromAssistantError, CreateAssistantTemplateFromAssistantResponse, CreateDatasetData, CreateDatasetError, CreateDatasetResponse, CreateMemoryFromThreadData, CreateMemoryFromThreadError, CreateMemoryFromThreadResponse, CreateProjectData, CreateProjectError, CreateProjectResponse, CreateSpaceData, CreateSpaceError, CreateSpaceMemoryItemData, CreateSpaceMemoryItemError, CreateSpaceMemoryItemResponse, CreateSpaceResponse, DeleteAssistantData, DeleteAssistantError, DeleteAssistantResponse, DeleteAssistantTemplateData, DeleteAssistantTemplateError, DeleteAssistantTemplateResponse, DeleteAssistantThreadData, DeleteAssistantThreadError, DeleteAssistantThreadResponse, DeleteDatasetData, DeleteDatasetError, DeleteDatasetResponse, DeleteDataSourcesData, DeleteDataSourcesError, DeleteDataSourcesResponse, DeleteProjectData, DeleteProjectError, DeleteProjectResponse, DeleteSpaceData, DeleteSpaceError, DeleteSpaceMemoryItemData, DeleteSpaceMemoryItemError, DeleteSpaceMemoryItemResponse, DeleteSpaceResponse, DeleteThreadData, DeleteThreadError, DeleteThreadResponse, GenerateFileUploadUrlsData, GenerateFileUploadUrlsError, GenerateFileUploadUrlsResponse, GenerateS3PresignedUrlsData, GenerateS3PresignedUrlsError, GenerateS3PresignedUrlsResponse, GenerateSpaceFileUploadUrlsData, GenerateSpaceFileUploadUrlsError, GenerateSpaceFileUploadUrlsResponse, GenerateThreadMemorySummaryData, GenerateThreadMemorySummaryError, GenerateThreadMemorySummaryResponse, GetAssistantChangelogData, GetAssistantChangelogError, GetAssistantChangelogResponse, GetAssistantData, GetAssistantError, GetAssistantResponse, GetAssistantTemplateData, GetAssistantTemplateError, GetAssistantTemplateResponse, GetAssistantThreadByIdData, GetAssistantThreadByIdError, GetAssistantThreadByIdResponse, GetDatasetByIdData, GetDatasetByIdError, GetDatasetByIdResponse, GetDragDatasetByIdData, GetDragDatasetByIdError, GetDragProjectByIdData, GetDragProjectByIdError, GetProjectByIdData, GetProjectByIdError, GetProjectByIdResponse, GetProjectChangelogData, GetProjectChangelogError, GetProjectChangelogResponse, GetRagSourcesData, GetRagSourcesError, GetRagSourcesResponse, GetReferenceDataData, GetReferenceDataError, GetReferenceDataResponse, GetSpaceByIdData, GetSpaceByIdError, GetSpaceByIdResponse, GetSpaceMemoryData, GetSpaceMemoryError, GetSpaceMemoryItemData, GetSpaceMemoryItemError, GetSpaceMemoryItemResponse, GetSpaceMemoryResponse, GetSpaceMemorySyncStatusData, GetSpaceMemorySyncStatusError, GetSpaceMemorySyncStatusResponse, GetThreadByIdData, GetThreadByIdError, GetThreadByIdResponse, GetThreadMemorySummaryData, GetThreadMemorySummaryError, GetThreadMemorySummaryResponse, GetUserProfileData, GetUserProfileError, GetUserProfileResponse, LambdaChatChatPostData, LambdaChatChatPostError, LambdaChatChatPostResponse, ListAssistantsData, ListAssistantsError, ListAssistantsResponse, ListAssistantTemplatesData, ListAssistantTemplatesError, ListAssistantTemplatesResponse, ListAssistantThreadsData, ListAssistantThreadsError, ListAssistantThreadsResponse, ListDatasetsData, ListDatasetsError, ListDatasetsResponse, ListDataSourcesData, ListDataSourcesError, ListDataSourcesResponse, ListProjectsData, ListProjectsError, ListProjectsResponse, ListProjectThreadsData, ListProjectThreadsError, ListProjectThreadsResponse, ListSpaceMemoryItemsData, ListSpaceMemoryItemsError, ListSpaceMemoryItemsResponse, ListSpacesData, ListSpacesError, ListSpacesResponse, ProcessDragData, ProcessDragError, ProcessDragResponse, ProcessFilesData, ProcessFilesError, ProcessFilesResponse, SearchUsersData, SearchUsersError, SearchUsersResponse, SyncSpaceMemoryData, SyncSpaceMemoryError, SyncSpaceMemoryResponse, SynthesizeSpaceMemoryData, SynthesizeSpaceMemoryError, SynthesizeSpaceMemoryResponse, UpdateAssistantData, UpdateAssistantError, UpdateAssistantResponse, UpdateAssistantTemplateData, UpdateAssistantTemplateError, UpdateAssistantTemplateResponse, UpdateAssistantThreadData, UpdateAssistantThreadError, UpdateAssistantThreadResponse, UpdateDatasetData, UpdateDatasetError, UpdateDatasetResponse, UpdateDataSourcesData, UpdateDataSourcesError, UpdateDataSourcesResponse, UpdateProjectData, UpdateProjectError, UpdateProjectResponse, UpdateSpaceData, UpdateSpaceError, UpdateSpaceMemoryItemData, UpdateSpaceMemoryItemError, UpdateSpaceMemoryItemResponse, UpdateSpaceResponse, UpdateThreadData, UpdateThreadError, UpdateThreadResponse, UpdateUserProfileData, UpdateUserProfileError, UpdateUserProfileResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getReferenceDataQueryKey = (options?: Options<GetReferenceDataData>) => createQueryKey('getReferenceData', options);

/**
 * Get Referencedata
 *
 * Get reference data for the authenticated application. Returns configuration and lookup values such as available AI models, chunk sizes, retrieval counts, data classifications, file types, and other dropdown/lookup data used by the application. Requires authentication.
 */
export const getReferenceDataOptions = (options?: Options<GetReferenceDataData>) => queryOptions<GetReferenceDataResponse, GetReferenceDataError, GetReferenceDataResponse, ReturnType<typeof getReferenceDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReferenceData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReferenceDataQueryKey(options)
});

export const getUserProfileQueryKey = (options?: Options<GetUserProfileData>) => createQueryKey('getUserProfile', options);

/**
 * Get User
 *
 * Get the current authenticated user's details. Requires authentication.
 */
export const getUserProfileOptions = (options?: Options<GetUserProfileData>) => queryOptions<GetUserProfileResponse, GetUserProfileError, GetUserProfileResponse, ReturnType<typeof getUserProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserProfileQueryKey(options)
});

/**
 * Put User
 */
export const updateUserProfileMutation = (options?: Partial<Options<UpdateUserProfileData>>): UseMutationOptions<UpdateUserProfileResponse, UpdateUserProfileError, Options<UpdateUserProfileData>> => {
    const mutationOptions: UseMutationOptions<UpdateUserProfileResponse, UpdateUserProfileError, Options<UpdateUserProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateUserProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchUsersQueryKey = (options: Options<SearchUsersData>) => createQueryKey('searchUsers', options);

/**
 * Search Users
 *
 * Search for users by email, username, name, or all fields using Okta directory
 *
 * Args:
 * search: The search term to look for
 * search_type: Type of search (email, username, name, both, or all)
 * - email: Search by email address only
 * - username: Search by username/login only
 * - name: Search by first or last name
 * - both: Search by email and username (default)
 * - all: Search across email, username, firstName, and lastName
 *
 * Returns:
 * A list of matching users with id, email, login, firstName, and lastName.
 * Returns empty list if no matches found (not an error).
 */
export const searchUsersOptions = (options: Options<SearchUsersData>) => queryOptions<SearchUsersResponse, SearchUsersError, SearchUsersResponse, ReturnType<typeof searchUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchUsersQueryKey(options)
});

export const listDatasetsQueryKey = (options?: Options<ListDatasetsData>) => createQueryKey('listDatasets', options);

/**
 * Get Datasets
 *
 * List all datasets accessible to the authenticated user. Returns datasets where the user has OWNER, CONTRIBUTOR, or VIEWER role.
 */
export const listDatasetsOptions = (options?: Options<ListDatasetsData>) => queryOptions<ListDatasetsResponse, ListDatasetsError, ListDatasetsResponse, ReturnType<typeof listDatasetsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDatasets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDatasetsQueryKey(options)
});

/**
 * Post Datasets
 *
 * Create a new dataset. Supports both RAG and DRAG type datasets with configurable vector settings, data sources, and access controls. Returns the created dataset with owner role assigned.
 */
export const createDatasetMutation = (options?: Partial<Options<CreateDatasetData>>): UseMutationOptions<CreateDatasetResponse, CreateDatasetError, Options<CreateDatasetData>> => {
    const mutationOptions: UseMutationOptions<CreateDatasetResponse, CreateDatasetError, Options<CreateDatasetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDataset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Dataset
 *
 * Delete a dataset by ID. The dataset must not be in use by any projects and a datasource must not be linked to any assistants. Requires OWNER role. Returns 204 No Content upon successful deletion.
 */
export const deleteDatasetMutation = (options?: Partial<Options<DeleteDatasetData>>): UseMutationOptions<DeleteDatasetResponse, DeleteDatasetError, Options<DeleteDatasetData>> => {
    const mutationOptions: UseMutationOptions<DeleteDatasetResponse, DeleteDatasetError, Options<DeleteDatasetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDataset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDatasetByIdQueryKey = (options: Options<GetDatasetByIdData>) => createQueryKey('getDatasetById', options);

/**
 * Get Dataset
 *
 * Get details of a specific dataset by ID. Returns comprehensive information including vector configuration, data sources, sharing settings, and the user's role for the dataset.
 */
export const getDatasetByIdOptions = (options: Options<GetDatasetByIdData>) => queryOptions<GetDatasetByIdResponse, GetDatasetByIdError, GetDatasetByIdResponse, ReturnType<typeof getDatasetByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDatasetById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDatasetByIdQueryKey(options)
});

/**
 * Put Dataset
 *
 * Update an existing dataset's configuration. Can modify metadata, vector settings, and sharing permissions. Requires OWNER or CONTRIBUTOR role.
 */
export const updateDatasetMutation = (options?: Partial<Options<UpdateDatasetData>>): UseMutationOptions<UpdateDatasetResponse, UpdateDatasetError, Options<UpdateDatasetData>> => {
    const mutationOptions: UseMutationOptions<UpdateDatasetResponse, UpdateDatasetError, Options<UpdateDatasetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDataset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDragDatasetByIdQueryKey = (options: Options<GetDragDatasetByIdData>) => createQueryKey('getDragDatasetById', options);

/**
 * Get Drag Dataset
 *
 * Get details of a specific DRAG dataset by ID without response model validation. Returns raw dataset data including all DRAG-specific fields like drag_S3_configuration, drag_statistics, and other DRAG-related configuration.
 */
export const getDragDatasetByIdOptions = (options: Options<GetDragDatasetByIdData>) => queryOptions<unknown, GetDragDatasetByIdError, unknown, ReturnType<typeof getDragDatasetByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDragDatasetById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDragDatasetByIdQueryKey(options)
});

/**
 * Delete Datasources
 *
 * Remove all data sources from a dataset. Must not be in use. Requires appropriate permissions. Returns 204 No Content upon successful deletion.
 */
export const deleteDataSourcesMutation = (options?: Partial<Options<DeleteDataSourcesData>>): UseMutationOptions<DeleteDataSourcesResponse, DeleteDataSourcesError, Options<DeleteDataSourcesData>> => {
    const mutationOptions: UseMutationOptions<DeleteDataSourcesResponse, DeleteDataSourcesError, Options<DeleteDataSourcesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDataSources({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDataSourcesQueryKey = (options: Options<ListDataSourcesData>) => createQueryKey('listDataSources', options);

/**
 * Get Datasources
 *
 * List all data sources associated with a dataset. Returns information about files, their processing status, and ingestion statistics.
 *
 * This endpoint follows the collection response pattern:
 * - Response: {"dataSources": [...]} - Array of datasource objects
 *
 * Each datasource object includes metadata about the file, processing status, ingestion statistics, and S3 location.
 */
export const listDataSourcesOptions = (options: Options<ListDataSourcesData>) => queryOptions<ListDataSourcesResponse, ListDataSourcesError, ListDataSourcesResponse, ReturnType<typeof listDataSourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDataSources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDataSourcesQueryKey(options)
});

/**
 * Patch Datasources
 *
 * Update data sources for a dataset. Can modify source configurations. Requires appropriate permissions.
 *
 * This endpoint follows the collection update pattern:
 * - Request: {"dataSources": [...]} - Array of datasource objects to update
 * - Response: {"dataSources": [...]} - Array of updated datasource objects
 *
 * Each datasource object in the request should include the 'id' field to identify which datasource to update.
 * Only provided fields will be updated (partial update).
 */
export const updateDataSourcesMutation = (options?: Partial<Options<UpdateDataSourcesData>>): UseMutationOptions<UpdateDataSourcesResponse, UpdateDataSourcesError, Options<UpdateDataSourcesData>> => {
    const mutationOptions: UseMutationOptions<UpdateDataSourcesResponse, UpdateDataSourcesError, Options<UpdateDataSourcesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDataSources({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Post Process Files
 *
 * Initiates processing of uploaded files within a dataset. This includes vectorization, chunking, and indexing of documents for search and retrieval. Can optionally force reprocessing of already processed files. Requires CONTRIBUTOR or OWNER role.
 */
export const processFilesMutation = (options?: Partial<Options<ProcessFilesData>>): UseMutationOptions<ProcessFilesResponse, ProcessFilesError, Options<ProcessFilesData>> => {
    const mutationOptions: UseMutationOptions<ProcessFilesResponse, ProcessFilesError, Options<ProcessFilesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await processFiles({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Post S3 Presigned Urls
 *
 * Generates S3 presigned URLs for uploading files to a specified dataset. Returns the presigned URLs that can be used for direct file uploads to S3.
 */
export const generateS3PresignedUrlsMutation = (options?: Partial<Options<GenerateS3PresignedUrlsData>>): UseMutationOptions<GenerateS3PresignedUrlsResponse, GenerateS3PresignedUrlsError, Options<GenerateS3PresignedUrlsData>> => {
    const mutationOptions: UseMutationOptions<GenerateS3PresignedUrlsResponse, GenerateS3PresignedUrlsError, Options<GenerateS3PresignedUrlsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateS3PresignedUrls({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Post Project File Upload Urls
 *
 * Generates S3 presigned POST URLs for uploading files to a project. Returns the presigned data for direct uploads to S3.
 */
export const generateFileUploadUrlsMutation = (options?: Partial<Options<GenerateFileUploadUrlsData>>): UseMutationOptions<GenerateFileUploadUrlsResponse, GenerateFileUploadUrlsError, Options<GenerateFileUploadUrlsData>> => {
    const mutationOptions: UseMutationOptions<GenerateFileUploadUrlsResponse, GenerateFileUploadUrlsError, Options<GenerateFileUploadUrlsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateFileUploadUrls({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listProjectsQueryKey = (options?: Options<ListProjectsData>) => createQueryKey('listProjects', options);

/**
 * Get Projects
 *
 * List all projects accessible to the authenticated user. Returns projects where the user has OWNER, CONTRIBUTOR, or VIEWER role. Each project includes configuration details, associated datasets, and the user's role.
 */
export const listProjectsOptions = (options?: Options<ListProjectsData>) => queryOptions<ListProjectsResponse, ListProjectsError, ListProjectsResponse, ReturnType<typeof listProjectsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProjects({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProjectsQueryKey(options)
});

/**
 * Post Project
 *
 * Create a new AI project. Projects are workspaces that combine datasets with LLM configurations, prompts, and query settings to interact with a dataset. Returns the created project with owner role assigned.
 */
export const createProjectMutation = (options?: Partial<Options<CreateProjectData>>): UseMutationOptions<CreateProjectResponse, CreateProjectError, Options<CreateProjectData>> => {
    const mutationOptions: UseMutationOptions<CreateProjectResponse, CreateProjectError, Options<CreateProjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createProject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Project
 *
 * Delete a project by ID. This will also remove all associated threads and conversation history. Requires OWNER role. Returns 204 No Content upon successful deletion.
 */
export const deleteProjectMutation = (options?: Partial<Options<DeleteProjectData>>): UseMutationOptions<DeleteProjectResponse, DeleteProjectError, Options<DeleteProjectData>> => {
    const mutationOptions: UseMutationOptions<DeleteProjectResponse, DeleteProjectError, Options<DeleteProjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteProject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectByIdQueryKey = (options: Options<GetProjectByIdData>) => createQueryKey('getProjectById', options);

/**
 * Get Project
 *
 * Get details of a specific project by ID. Returns comprehensive project information including LLM configuration, dataset associations, prompts, query settings, sharing permissions, and the user's role for the project.
 */
export const getProjectByIdOptions = (options: Options<GetProjectByIdData>) => queryOptions<GetProjectByIdResponse, GetProjectByIdError, GetProjectByIdResponse, ReturnType<typeof getProjectByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProjectById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProjectByIdQueryKey(options)
});

/**
 * Put Project
 *
 * Update an existing project's configuration. Can modify metadata, LLM settings, prompts, query parameters, dataset associations, and sharing permissions. Requires OWNER or CONTRIBUTOR role.
 */
export const updateProjectMutation = (options?: Partial<Options<UpdateProjectData>>): UseMutationOptions<UpdateProjectResponse, UpdateProjectError, Options<UpdateProjectData>> => {
    const mutationOptions: UseMutationOptions<UpdateProjectResponse, UpdateProjectError, Options<UpdateProjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateProject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDragProjectByIdQueryKey = (options: Options<GetDragProjectByIdData>) => createQueryKey('getDragProjectById', options);

/**
 * Get Drag Project
 *
 * Get details of a specific DRAG project by ID without response model validation. Returns raw project data including all DRAG-specific fields like prompt_template_id_matches, match_unique_tag, and process_status.
 */
export const getDragProjectByIdOptions = (options: Options<GetDragProjectByIdData>) => queryOptions<unknown, GetDragProjectByIdError, unknown, ReturnType<typeof getDragProjectByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDragProjectById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDragProjectByIdQueryKey(options)
});

/**
 * Post Process Drag
 *
 * Initiates DRAG (Deterministic Retrieval-Augmented Generation) processing for a project. This prepares the project's dataset for enhanced AI interactions by processing and optimizing the data for retrieval operations. Returns job details for tracking processing status. TO BE DEPRECATED IN FUTURE RELEASES.
 */
export const processDragMutation = (options?: Partial<Options<ProcessDragData>>): UseMutationOptions<ProcessDragResponse, ProcessDragError, Options<ProcessDragData>> => {
    const mutationOptions: UseMutationOptions<ProcessDragResponse, ProcessDragError, Options<ProcessDragData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await processDrag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectChangelogQueryKey = (options: Options<GetProjectChangelogData>) => createQueryKey('getProjectChangelog', options);

/**
 * Get Changelog
 *
 * Get the changelog for a specific project. Returns a list of changes and modifications made to the project over time, useful for tracking project evolution and audit purposes.
 */
export const getProjectChangelogOptions = (options: Options<GetProjectChangelogData>) => queryOptions<GetProjectChangelogResponse, GetProjectChangelogError, GetProjectChangelogResponse, ReturnType<typeof getProjectChangelogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProjectChangelog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProjectChangelogQueryKey(options)
});

export const listProjectThreadsQueryKey = (options: Options<ListProjectThreadsData>) => createQueryKey('listProjectThreads', options);

/**
 * Get Threads
 *
 * List all conversation threads within a project. Threads represent individual chat sessions or conversations with the AI assistant. Returns thread metadata and conversation history. Optionally filter by assistant_id or space_id (cannot use both simultaneously).
 */
export const listProjectThreadsOptions = (options: Options<ListProjectThreadsData>) => queryOptions<ListProjectThreadsResponse, ListProjectThreadsError, ListProjectThreadsResponse, ReturnType<typeof listProjectThreadsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProjectThreads({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProjectThreadsQueryKey(options)
});

/**
 * Delete Thread
 *
 * Delete a specific conversation thread by ID. This will permanently remove the thread and all associated conversation history. Requires appropriate permissions. Returns 204 No Content upon successful deletion.
 */
export const deleteThreadMutation = (options?: Partial<Options<DeleteThreadData>>): UseMutationOptions<DeleteThreadResponse, DeleteThreadError, Options<DeleteThreadData>> => {
    const mutationOptions: UseMutationOptions<DeleteThreadResponse, DeleteThreadError, Options<DeleteThreadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteThread({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getThreadByIdQueryKey = (options: Options<GetThreadByIdData>) => createQueryKey('getThreadById', options);

/**
 * Get Thread
 *
 * Get details of a specific conversation thread by ID. Returns the complete conversation history, messages, and thread metadata for a particular chat session within a project.
 */
export const getThreadByIdOptions = (options: Options<GetThreadByIdData>) => queryOptions<GetThreadByIdResponse, GetThreadByIdError, GetThreadByIdResponse, ReturnType<typeof getThreadByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getThreadById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getThreadByIdQueryKey(options)
});

/**
 * Patch Thread
 *
 * Update an existing conversation thread. Can modify thread name and spaceId. Requires appropriate permissions.
 */
export const updateThreadMutation = (options?: Partial<Options<UpdateThreadData>>): UseMutationOptions<UpdateThreadResponse, UpdateThreadError, Options<UpdateThreadData>> => {
    const mutationOptions: UseMutationOptions<UpdateThreadResponse, UpdateThreadError, Options<UpdateThreadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateThread({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRagSourcesQueryKey = (options: Options<GetRagSourcesData>) => createQueryKey('getRagSources', options);

/**
 * Get Ragsource
 *
 * Get the RAG (Retrieval-Augmented Generation) sources for a specific message in a conversation thread. Returns the document sources and context that were used to generate the AI response for that particular message.
 */
export const getRagSourcesOptions = (options: Options<GetRagSourcesData>) => queryOptions<GetRagSourcesResponse, GetRagSourcesError, GetRagSourcesResponse, ReturnType<typeof getRagSourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRagSources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRagSourcesQueryKey(options)
});

export const listAssistantsQueryKey = (options: Options<ListAssistantsData>) => createQueryKey('listAssistants', options);

/**
 * Get Assistants
 *
 * List all assistants for a project. Requires authentication.
 */
export const listAssistantsOptions = (options: Options<ListAssistantsData>) => queryOptions<ListAssistantsResponse, ListAssistantsError, ListAssistantsResponse, ReturnType<typeof listAssistantsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAssistants({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAssistantsQueryKey(options)
});

/**
 * Create Assistant
 *
 * Create a new assistant in a project. Requires authentication.
 */
export const createAssistantMutation = (options?: Partial<Options<CreateAssistantData>>): UseMutationOptions<CreateAssistantResponse, CreateAssistantError, Options<CreateAssistantData>> => {
    const mutationOptions: UseMutationOptions<CreateAssistantResponse, CreateAssistantError, Options<CreateAssistantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAssistant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Assistant
 *
 * Delete an assistant in a project. Requires authentication.
 */
export const deleteAssistantMutation = (options?: Partial<Options<DeleteAssistantData>>): UseMutationOptions<DeleteAssistantResponse, DeleteAssistantError, Options<DeleteAssistantData>> => {
    const mutationOptions: UseMutationOptions<DeleteAssistantResponse, DeleteAssistantError, Options<DeleteAssistantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAssistant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAssistantQueryKey = (options: Options<GetAssistantData>) => createQueryKey('getAssistant', options);

/**
 * Get Assistant
 *
 * Get a specific assistant in a project. Requires authentication.
 */
export const getAssistantOptions = (options: Options<GetAssistantData>) => queryOptions<GetAssistantResponse, GetAssistantError, GetAssistantResponse, ReturnType<typeof getAssistantQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAssistant({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAssistantQueryKey(options)
});

/**
 * Update Assistant
 *
 * Update an assistant in a project. Requires authentication.
 */
export const updateAssistantMutation = (options?: Partial<Options<UpdateAssistantData>>): UseMutationOptions<UpdateAssistantResponse, UpdateAssistantError, Options<UpdateAssistantData>> => {
    const mutationOptions: UseMutationOptions<UpdateAssistantResponse, UpdateAssistantError, Options<UpdateAssistantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAssistant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAssistantChangelogQueryKey = (options: Options<GetAssistantChangelogData>) => createQueryKey('getAssistantChangelog', options);

/**
 * Get Assistant Changelog
 *
 * Get the changelog for a specific assistant. Returns a list of changes and modifications made to the assistant over time, useful for tracking assistant evolution and audit purposes.
 */
export const getAssistantChangelogOptions = (options: Options<GetAssistantChangelogData>) => queryOptions<GetAssistantChangelogResponse, GetAssistantChangelogError, GetAssistantChangelogResponse, ReturnType<typeof getAssistantChangelogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAssistantChangelog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAssistantChangelogQueryKey(options)
});

export const listAssistantTemplatesQueryKey = (options?: Options<ListAssistantTemplatesData>) => createQueryKey('listAssistantTemplates', options);

/**
 * List Assistant Templates
 *
 * List all assistant templates (with usage stats). Publicly readable.
 */
export const listAssistantTemplatesOptions = (options?: Options<ListAssistantTemplatesData>) => queryOptions<ListAssistantTemplatesResponse, ListAssistantTemplatesError, ListAssistantTemplatesResponse, ReturnType<typeof listAssistantTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAssistantTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAssistantTemplatesQueryKey(options)
});

/**
 * Create Assistant Template From Assistant
 *
 * Create a new assistant template from an existing assistant's configuration.
 */
export const createAssistantTemplateFromAssistantMutation = (options?: Partial<Options<CreateAssistantTemplateFromAssistantData>>): UseMutationOptions<CreateAssistantTemplateFromAssistantResponse, CreateAssistantTemplateFromAssistantError, Options<CreateAssistantTemplateFromAssistantData>> => {
    const mutationOptions: UseMutationOptions<CreateAssistantTemplateFromAssistantResponse, CreateAssistantTemplateFromAssistantError, Options<CreateAssistantTemplateFromAssistantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAssistantTemplateFromAssistant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Assistant Template
 *
 * Delete assistant template. Only owner can delete.
 */
export const deleteAssistantTemplateMutation = (options?: Partial<Options<DeleteAssistantTemplateData>>): UseMutationOptions<DeleteAssistantTemplateResponse, DeleteAssistantTemplateError, Options<DeleteAssistantTemplateData>> => {
    const mutationOptions: UseMutationOptions<DeleteAssistantTemplateResponse, DeleteAssistantTemplateError, Options<DeleteAssistantTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAssistantTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAssistantTemplateQueryKey = (options: Options<GetAssistantTemplateData>) => createQueryKey('getAssistantTemplate', options);

/**
 * Get Assistant Template
 *
 * Get specific assistant template (with usage records). Publicly readable.
 */
export const getAssistantTemplateOptions = (options: Options<GetAssistantTemplateData>) => queryOptions<GetAssistantTemplateResponse, GetAssistantTemplateError, GetAssistantTemplateResponse, ReturnType<typeof getAssistantTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAssistantTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAssistantTemplateQueryKey(options)
});

/**
 * Update Assistant Template
 *
 * Update assistant template. Only owner can update.
 */
export const updateAssistantTemplateMutation = (options?: Partial<Options<UpdateAssistantTemplateData>>): UseMutationOptions<UpdateAssistantTemplateResponse, UpdateAssistantTemplateError, Options<UpdateAssistantTemplateData>> => {
    const mutationOptions: UseMutationOptions<UpdateAssistantTemplateResponse, UpdateAssistantTemplateError, Options<UpdateAssistantTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAssistantTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAssistantThreadsQueryKey = (options: Options<ListAssistantThreadsData>) => createQueryKey('listAssistantThreads', options);

/**
 * Get Assistant Threads
 *
 * List all conversation threads for an assistant. Requires authentication.
 */
export const listAssistantThreadsOptions = (options: Options<ListAssistantThreadsData>) => queryOptions<ListAssistantThreadsResponse, ListAssistantThreadsError, ListAssistantThreadsResponse, ReturnType<typeof listAssistantThreadsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAssistantThreads({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAssistantThreadsQueryKey(options)
});

/**
 * Delete Assistant Thread
 *
 * Delete a specific assistant thread by ID. This will permanently remove the thread and all associated conversation history. Requires appropriate permissions. Returns 204 No Content upon successful deletion.
 */
export const deleteAssistantThreadMutation = (options?: Partial<Options<DeleteAssistantThreadData>>): UseMutationOptions<DeleteAssistantThreadResponse, DeleteAssistantThreadError, Options<DeleteAssistantThreadData>> => {
    const mutationOptions: UseMutationOptions<DeleteAssistantThreadResponse, DeleteAssistantThreadError, Options<DeleteAssistantThreadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAssistantThread({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAssistantThreadByIdQueryKey = (options: Options<GetAssistantThreadByIdData>) => createQueryKey('getAssistantThreadById', options);

/**
 * Get Assistant Thread
 *
 * Get details of a specific assistant thread by ID. Returns the complete conversation history, messages, and thread metadata for a particular chat session within an assistant.
 */
export const getAssistantThreadByIdOptions = (options: Options<GetAssistantThreadByIdData>) => queryOptions<GetAssistantThreadByIdResponse, GetAssistantThreadByIdError, GetAssistantThreadByIdResponse, ReturnType<typeof getAssistantThreadByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAssistantThreadById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAssistantThreadByIdQueryKey(options)
});

/**
 * Update Assistant Thread
 *
 * Update an existing assistant thread name. Only the thread name can be modified. Requires appropriate permissions.
 */
export const updateAssistantThreadMutation = (options?: Partial<Options<UpdateAssistantThreadData>>): UseMutationOptions<UpdateAssistantThreadResponse, UpdateAssistantThreadError, Options<UpdateAssistantThreadData>> => {
    const mutationOptions: UseMutationOptions<UpdateAssistantThreadResponse, UpdateAssistantThreadError, Options<UpdateAssistantThreadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAssistantThread({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSpacesQueryKey = (options?: Options<ListSpacesData>) => createQueryKey('listSpaces', options);

/**
 * Get Spaces
 *
 * List all spaces owned by the authenticated user.
 */
export const listSpacesOptions = (options?: Options<ListSpacesData>) => queryOptions<ListSpacesResponse, ListSpacesError, ListSpacesResponse, ReturnType<typeof listSpacesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSpaces({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSpacesQueryKey(options)
});

/**
 * Post Space
 *
 * Create a new space. The authenticated principal user is automatically set as the space owner. Returns the created space with generated ID.
 */
export const createSpaceMutation = (options?: Partial<Options<CreateSpaceData>>): UseMutationOptions<CreateSpaceResponse, CreateSpaceError, Options<CreateSpaceData>> => {
    const mutationOptions: UseMutationOptions<CreateSpaceResponse, CreateSpaceError, Options<CreateSpaceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSpace({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Space
 *
 * Delete a space by ID. Only allowed by space owner based on Principal UserId. Returns 204 No Content upon successful deletion.
 */
export const deleteSpaceMutation = (options?: Partial<Options<DeleteSpaceData>>): UseMutationOptions<DeleteSpaceResponse, DeleteSpaceError, Options<DeleteSpaceData>> => {
    const mutationOptions: UseMutationOptions<DeleteSpaceResponse, DeleteSpaceError, Options<DeleteSpaceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSpace({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSpaceByIdQueryKey = (options: Options<GetSpaceByIdData>) => createQueryKey('getSpaceById', options);

/**
 * Get Space
 *
 * Get details of a specific space by ID. Only accessible by the space owner based on Principal UserId.
 */
export const getSpaceByIdOptions = (options: Options<GetSpaceByIdData>) => queryOptions<GetSpaceByIdResponse, GetSpaceByIdError, GetSpaceByIdResponse, ReturnType<typeof getSpaceByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSpaceById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSpaceByIdQueryKey(options)
});

/**
 * Put Space
 *
 * Update an existing space's information. Can modify name, instructions, and attached files. Only allowed by space owner based on Principal UserId.
 */
export const updateSpaceMutation = (options?: Partial<Options<UpdateSpaceData>>): UseMutationOptions<UpdateSpaceResponse, UpdateSpaceError, Options<UpdateSpaceData>> => {
    const mutationOptions: UseMutationOptions<UpdateSpaceResponse, UpdateSpaceError, Options<UpdateSpaceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSpace({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Post Space File Upload Urls
 *
 * Generate S3 presigned POST URLs for uploading files to a space.
 *
 * Space files are stored persistently:
 * - Original: `spaces/{space_id}/{timestamp}_{filename}`
 * - Converted: `spaces/{space_id}/{timestamp}_{basename}.extracted.md`
 *
 * Unlike regular project files, space files are NOT deleted after text extraction.
 * Both the original and the extracted content are retained for persistent reference.
 *
 * The converted file path can be derived from the original by replacing the extension
 * with `.extracted.md`. The response includes `spaceId` and `isSpaceFile` flags.
 */
export const generateSpaceFileUploadUrlsMutation = (options?: Partial<Options<GenerateSpaceFileUploadUrlsData>>): UseMutationOptions<GenerateSpaceFileUploadUrlsResponse, GenerateSpaceFileUploadUrlsError, Options<GenerateSpaceFileUploadUrlsData>> => {
    const mutationOptions: UseMutationOptions<GenerateSpaceFileUploadUrlsResponse, GenerateSpaceFileUploadUrlsError, Options<GenerateSpaceFileUploadUrlsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateSpaceFileUploadUrls({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSpaceMemoryQueryKey = (options: Options<GetSpaceMemoryData>) => createQueryKey('getSpaceMemory', options);

/**
 * Get Space Memory
 *
 * Get synthesized memory for a space. Returns the unified memory summary combining implicit thread summaries and explicit user memories.
 */
export const getSpaceMemoryOptions = (options: Options<GetSpaceMemoryData>) => queryOptions<GetSpaceMemoryResponse, GetSpaceMemoryError, GetSpaceMemoryResponse, ReturnType<typeof getSpaceMemoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSpaceMemory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSpaceMemoryQueryKey(options)
});

export const getSpaceMemorySyncStatusQueryKey = (options: Options<GetSpaceMemorySyncStatusData>) => createQueryKey('getSpaceMemorySyncStatus', options);

/**
 * Get Space Memory Sync Status
 *
 * Check which threads have changes that need to be synced to space memory. Returns list of threads needing summary updates.
 */
export const getSpaceMemorySyncStatusOptions = (options: Options<GetSpaceMemorySyncStatusData>) => queryOptions<GetSpaceMemorySyncStatusResponse, GetSpaceMemorySyncStatusError, GetSpaceMemorySyncStatusResponse, ReturnType<typeof getSpaceMemorySyncStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSpaceMemorySyncStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSpaceMemorySyncStatusQueryKey(options)
});

/**
 * Sync Space Memory
 *
 * Smart sync: update only changed threads and resynthesize space memory. Only regenerates summaries for threads with new messages. Requires project_id to fetch thread data.
 */
export const syncSpaceMemoryMutation = (options?: Partial<Options<SyncSpaceMemoryData>>): UseMutationOptions<SyncSpaceMemoryResponse, SyncSpaceMemoryError, Options<SyncSpaceMemoryData>> => {
    const mutationOptions: UseMutationOptions<SyncSpaceMemoryResponse, SyncSpaceMemoryError, Options<SyncSpaceMemoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await syncSpaceMemory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Synthesize Space Memory Endpoint
 *
 * Synthesize space memory from current memory items. Uses existing thread summaries without regeneration.
 */
export const synthesizeSpaceMemoryMutation = (options?: Partial<Options<SynthesizeSpaceMemoryData>>): UseMutationOptions<SynthesizeSpaceMemoryResponse, SynthesizeSpaceMemoryError, Options<SynthesizeSpaceMemoryData>> => {
    const mutationOptions: UseMutationOptions<SynthesizeSpaceMemoryResponse, SynthesizeSpaceMemoryError, Options<SynthesizeSpaceMemoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await synthesizeSpaceMemory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk Delete Memory Items
 *
 * Bulk delete memory items. Can delete all items, only implicit summaries, or only explicit memories.
 */
export const bulkDeleteSpaceMemoryItemsMutation = (options?: Partial<Options<BulkDeleteSpaceMemoryItemsData>>): UseMutationOptions<unknown, BulkDeleteSpaceMemoryItemsError, Options<BulkDeleteSpaceMemoryItemsData>> => {
    const mutationOptions: UseMutationOptions<unknown, BulkDeleteSpaceMemoryItemsError, Options<BulkDeleteSpaceMemoryItemsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkDeleteSpaceMemoryItems({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSpaceMemoryItemsQueryKey = (options: Options<ListSpaceMemoryItemsData>) => createQueryKey('listSpaceMemoryItems', options);

/**
 * Get Memory Items
 *
 * List all memory items for a space. Can filter by source type (implicit_summary or explicit).
 */
export const listSpaceMemoryItemsOptions = (options: Options<ListSpaceMemoryItemsData>) => queryOptions<ListSpaceMemoryItemsResponse, ListSpaceMemoryItemsError, ListSpaceMemoryItemsResponse, ReturnType<typeof listSpaceMemoryItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSpaceMemoryItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSpaceMemoryItemsQueryKey(options)
});

/**
 * Create Memory Item
 *
 * Create a new memory item. Can be implicit (references thread summary) or explicit (user-created content).
 */
export const createSpaceMemoryItemMutation = (options?: Partial<Options<CreateSpaceMemoryItemData>>): UseMutationOptions<CreateSpaceMemoryItemResponse, CreateSpaceMemoryItemError, Options<CreateSpaceMemoryItemData>> => {
    const mutationOptions: UseMutationOptions<CreateSpaceMemoryItemResponse, CreateSpaceMemoryItemError, Options<CreateSpaceMemoryItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSpaceMemoryItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Memory Item
 *
 * Delete a memory item (soft delete - marks as excluded). Returns 204 No Content upon successful deletion.
 */
export const deleteSpaceMemoryItemMutation = (options?: Partial<Options<DeleteSpaceMemoryItemData>>): UseMutationOptions<DeleteSpaceMemoryItemResponse, DeleteSpaceMemoryItemError, Options<DeleteSpaceMemoryItemData>> => {
    const mutationOptions: UseMutationOptions<DeleteSpaceMemoryItemResponse, DeleteSpaceMemoryItemError, Options<DeleteSpaceMemoryItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSpaceMemoryItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSpaceMemoryItemQueryKey = (options: Options<GetSpaceMemoryItemData>) => createQueryKey('getSpaceMemoryItem', options);

/**
 * Get Memory Item
 *
 * Get a specific memory item by ID.
 */
export const getSpaceMemoryItemOptions = (options: Options<GetSpaceMemoryItemData>) => queryOptions<GetSpaceMemoryItemResponse, GetSpaceMemoryItemError, GetSpaceMemoryItemResponse, ReturnType<typeof getSpaceMemoryItemQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSpaceMemoryItem({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSpaceMemoryItemQueryKey(options)
});

/**
 * Update Memory Item
 *
 * Update a memory item. Only explicit memories can be updated (content, tags, importance).
 */
export const updateSpaceMemoryItemMutation = (options?: Partial<Options<UpdateSpaceMemoryItemData>>): UseMutationOptions<UpdateSpaceMemoryItemResponse, UpdateSpaceMemoryItemError, Options<UpdateSpaceMemoryItemData>> => {
    const mutationOptions: UseMutationOptions<UpdateSpaceMemoryItemResponse, UpdateSpaceMemoryItemError, Options<UpdateSpaceMemoryItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSpaceMemoryItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Memory From Thread
 *
 * Create an explicit memory from a thread message. Shortcut for creating explicit memories tied to specific threads.
 */
export const createMemoryFromThreadMutation = (options?: Partial<Options<CreateMemoryFromThreadData>>): UseMutationOptions<CreateMemoryFromThreadResponse, CreateMemoryFromThreadError, Options<CreateMemoryFromThreadData>> => {
    const mutationOptions: UseMutationOptions<CreateMemoryFromThreadResponse, CreateMemoryFromThreadError, Options<CreateMemoryFromThreadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMemoryFromThread({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getThreadMemorySummaryQueryKey = (options: Options<GetThreadMemorySummaryData>) => createQueryKey('getThreadMemorySummary', options);

/**
 * Get Thread Summary
 *
 * Get memory summary for a specific thread. Requires project_id to locate the thread.
 */
export const getThreadMemorySummaryOptions = (options: Options<GetThreadMemorySummaryData>) => queryOptions<GetThreadMemorySummaryResponse, GetThreadMemorySummaryError, GetThreadMemorySummaryResponse, ReturnType<typeof getThreadMemorySummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getThreadMemorySummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getThreadMemorySummaryQueryKey(options)
});

/**
 * Generate Thread Summary
 *
 * Generate memory summary for a thread using AI. Updates the thread's memory_summary field. Requires project_id to locate the thread.
 */
export const generateThreadMemorySummaryMutation = (options?: Partial<Options<GenerateThreadMemorySummaryData>>): UseMutationOptions<GenerateThreadMemorySummaryResponse, GenerateThreadMemorySummaryError, Options<GenerateThreadMemorySummaryData>> => {
    const mutationOptions: UseMutationOptions<GenerateThreadMemorySummaryResponse, GenerateThreadMemorySummaryError, Options<GenerateThreadMemorySummaryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateThreadMemorySummary({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Lambda Chat
 */
export const lambdaChatChatPostMutation = (options?: Partial<Options<LambdaChatChatPostData>>): UseMutationOptions<LambdaChatChatPostResponse, LambdaChatChatPostError, Options<LambdaChatChatPostData>> => {
    const mutationOptions: UseMutationOptions<LambdaChatChatPostResponse, LambdaChatChatPostError, Options<LambdaChatChatPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await lambdaChatChatPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
